import { ApiResponse } from 'services';
import { ResponseCode } from 'enums';

export const convertResponse = <T, U>(response: any) => {
  return response.code && response.message !== undefined && response.payload !== undefined
    ? {
        code: response.code,
        message: response.message,
        payload: response.payload,
      }
    : {
        code: ResponseCode.OK,
        message: '',
        payload: response as ApiResponse<T, U>['payload'],
      };
};
